module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-box"
  }, [(_vm.show_user) ? _c('div', {
    staticClass: "user-mask"
  }) : _vm._e(), _vm._v(" "), (_vm.show_user) ? _c('div', {
    staticClass: "user-mask-model",
    on: {
      "click": function($event) {
        _vm.show_user = false
      }
    }
  }, [(_vm.data) ? _c('div', {
    staticClass: "user-mask-model-rect",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "user-mask-model-rect-user"
  }, [_c('div', {
    staticClass: "user-mask-model-rect-user-left"
  }, [_c('img', {
    staticClass: "user-mask-model-rect-user-left-img",
    attrs: {
      "src": _vm.data.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-user-content"
  }, [_c('span', {
    staticClass: "user-mask-model-rect-user-content-span"
  }, [_vm._v(_vm._s(_vm.data.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "user-mask-model-rect-user-content-span1"
  }, [_vm._v("ID：" + _vm._s(_vm.data.recodeCode))])])]), _vm._v(" "), _c('img', {
    staticClass: "user-mask-model-rect-user-img",
    attrs: {
      "src": require("../../assets/image/tanchuang_x_b@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.show_user = false
      }
    }
  })]), _vm._v(" "), (_vm.isAdmin == 1) ? _c('div', {
    staticClass: "user-mask-model-rect-btn"
  }, [_c('div', {
    staticClass: "user-mask-model-rect-btn-item",
    on: {
      "click": _vm.addAdmin
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tianjiaguanliyuan')))]), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-btn-xian"
  }), _vm._v(" "), (_vm.data && _vm.data.subjoinParameter && _vm.data.subjoinParameter.chatRoomUserCurrentRecordsInfo && _vm.data.subjoinParameter.chatRoomUserCurrentRecordsInfo.isBannedToPost == 0) ? _c('div', {
    staticClass: "user-mask-model-rect-btn-item",
    on: {
      "click": _vm.bannedToPostUser
    }
  }, [_vm._v(_vm._s(_vm.$t('all.jinyan')))]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.subjoinParameter && _vm.data.subjoinParameter.chatRoomUserCurrentRecordsInfo && _vm.data.subjoinParameter.chatRoomUserCurrentRecordsInfo.isBannedToPost == 1) ? _c('div', {
    staticClass: "user-mask-model-rect-btn-item",
    on: {
      "click": _vm.relieveBannedToPostUser
    }
  }, [_vm._v(_vm._s(_vm.$t('all.jiechuejinyan')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-btn-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-btn-item",
    on: {
      "click": _vm.kickOutChatRoom
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tichufangjian')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "user-mask-model-rect-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "user-mask-model-rect-list-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('zbjlItem', {
      key: index,
      attrs: {
        "data": item
      }
    })
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70e8d0e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/user.vue
// module id = 984
// module chunks = 1